const observer: {
  handlers: Map<string, (entry: ResizeObserverEntry) => void>
  instance: ResizeObserver | null
} = {
  handlers: new Map(),
  instance: new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const element = entry.target
      const elementId = element.id

      const observerHandler = observer.handlers.get(elementId)

      if (!observerHandler) {
        return
      }

      observerHandler(entry)
    })
  }),
}

export const resizeObserver = {
  observe(elementId: string, callback: () => void) {
    const element = document.getElementById(elementId)

    if (!element) {
      return
    }

    observer.handlers.set(elementId, callback)
    observer.instance?.observe(element)
  },
  unobserve(elementId: string) {
    const element = document.getElementById(elementId)

    observer.handlers.delete(elementId)

    if (!element) {
      return
    }

    observer.instance?.unobserve(element)
  },
}
